import { App3D } from "./App3D";
import { Utils } from "./Utils";

import '../exports/jquery';
import '../exports/app';

import * as _ from "lodash";

export class GUI{
	protected coreEventsAttached = false;
	protected isTouch = false;
	protected $gui:JQuery;

	protected screenshotProcessorURL = 'rest/send-screenshot';
	protected reportData: { [k:string]:string } = {};

	constructor(
		protected app3D:App3D, guiParent:JQuery|string=null){
		this.$gui = this.app3D.$(guiParent ? guiParent : 'body');
	}

	/**
	 * Retuns value of GUI element (if found and set), null otherwise
	 * @param propertyName Property id
	 */
	propertyValue(propertyName: string): string{
		const $e = this.$gui.find(`input[name="${propertyName}"]:checked`);
		return $e.length
			? $e.val()
			: null;
	}

	/**
	 * One-time attachment of general non-navigation GUI events
	 */
	attachGUIEvents():void{
		if (this.coreEventsAttached)
			return;
		this.coreEventsAttached = true;
		let $body = this.app3D.$('body');

		// automatically close menus when navigating
		this.app3D.navigator.$eActivate.mousedown(() => {
			this.$gui.find('fieldset.fs-toggle.auto-close').removeClass('open');
		});

		if (typeof Hammer == 'function'){
			delete Hammer.defaults.cssProps.userSelect;
			let hammer = new Hammer($body[0], {});
			_.each(['pan'], (evt) => {
				hammer.get(evt).set({	threshold: 0 });
				hammer.on(evt, (e) => {
					if  (e.pointerType == 'touch')
						this.setTouchEnvironment();
				});
			});
		}

		// screenshotModal
		this.app3D.$('button[data-action="takeScreenshot"]').click(() => { this.takeScreenshot(); });
		this.app3D.$('button[data-action="sendScreenshot"]').click(() => { this.submitScreenshot(); });
	}

	/**
	 * Product switching
	 */
	attachProductMenuEvents():void{
		let app3D = this.app3D;
		let $gui = this.$gui;
		let gui = this;
		this.$gui.find('input[name="product"]').change(function () {
			let p = gui.app3D.$(this);
			let p_val = p.val();
			let p_opt = app3D.data.products[p_val];
			let pl = $gui.find('.modelSelect').find('li');
			pl.removeClass('active');
			pl.filter('[data-model="'+p_val+'"]').addClass('active');
			app3D.setProductVariant(p_val).then(() => {
				let fsl = $gui.find('#property-listing').find('fieldset');
				fsl.addClass('disabled');
				_.each(p_opt.properties, (prop) => {
					fsl.filter('[data-property="'+prop+'"]').removeClass('disabled');
				});
				gui.closeSubmenus();
				let $mName = $gui.find('#model-name');
				if ($mName.is('img'))
					$mName.attr('alt', p_opt.code);
				else
					$mName.text(p_opt.code);
			});
		});
	}

	/**
	 * basic productPropertyEvents
	 */
	protected attachEventsProductProperty(){
		let fsAll = this.$gui.find('fieldset.fs-toggle');
		let gui = this;
		fsAll.each(function () {
			let fs =  gui.app3D.$(this);
			fs.find('button.fs-toggle').click(function () {
				if (fs.hasClass('open')){
					fs.removeClass('open');
				}
				else{
					fsAll.not(fs).removeClass('open');
					fs.addClass('open');
				}
			});
		});

// Clicking option group legend causes parent fieldset to toggle "open" class
		let propList = this.$gui.find('fieldset.product-property');
		propList.each(function () {
			let fs = gui.app3D.$(this);
			let pType = fs.attr('data-property-type');
			if (pType == 'color')
				return true;

			fs.find('legend').click(function () {
				let was_open = fs.hasClass('open');
				propList.removeClass('open');
				if (!was_open)
					fs.addClass('open');
			});
			fs.find('li.option-group').each(function () {
				let og = gui.app3D.$(this);
				og.children('span.group-label').click(() => {
					let was_open = og.hasClass('open');
					og.parent().find('li.option-group').not(og).removeClass('open');
					if (!was_open)
						og.addClass('open');
				});
			});
		});
	}

	protected colorPropertyChange(property: string, newVal: string){
		if (this.app3D.data.properties.hasOwnProperty(property))
			this.app3D.setProperty(property, newVal);
	}

	protected scrollPropertyChange(property: string, $optList: JQuery, offset: number){
		let $liOld = $optList.find('input:checked').closest('li');
		let $liAll = $optList.find('li');
		// find what to show
		let $liNew = (offset < 0) // neighbour sibling if exits
			? $liOld.prev()
			: $liOld.next();
		if (!$liNew.length)	// ..if don't, then item from opposite end of list
			$liNew = (offset < 0)
				? $liAll.last()
				: $liAll.first();

		// check new value
		let newVal = $liNew.attr('data-value');

		if (this.app3D.data.properties.hasOwnProperty(property))
			this.app3D.setProperty(property, newVal);

		$liOld.find('input').removeAttr('checked');
		$liNew.find('input').attr('checked', 'checked');

		// animate
		let itemWidth = $optList.outerWidth();
		// set position and display
		$liNew.addClass('active');
		$liNew.css({
			'left': (offset < 0) ? -itemWidth : itemWidth,
		});
		let animDir = (offset < 0) ? '+=' : '-=';
		let duration = 500;
		$liNew.animate({left: animDir+itemWidth}, duration);
		$liOld.animate({left: animDir+itemWidth}, duration, () => {
			$liOld.removeClass('active');
		});
	}

	protected attachEventsScrollProperty(){
		let gui = this;
		this.$gui.find('fieldset.product-property-scroll').each(function () {
			let $pControl = gui.app3D.$(this);
			let property = $pControl.attr('data-property');
			let $optList = $pControl.find('ul');
			$pControl.find('button[data-action="item-prev"]').click(() => { gui.scrollPropertyChange(property, $optList, -1); });
			$pControl.find('button[data-action="item-next"]').click(() => { gui.scrollPropertyChange(property, $optList, 1); });
		});
	}

	protected attachEventsColorProperty(){
		let gui = this;
		this.$gui.find('fieldset.product-property-color').each(function () {
			let $pControl = gui.app3D.$(this);
			let property = $pControl.attr('data-property');

			$pControl.find('input.color-property').on('slidermove', function() {
				// this.app3D.$('#event-color').val();
				gui.colorPropertyChange(property, gui.app3D.$(this).wheelColorPicker('getValue', 'hex'));
			});
			//
			// $pControl.find('input.color-property').on('change', function() {
			// 	$('#event-input').val('Changed');
			// });
			//
			// $pControl.find('input.color-property').change(function() {
			// 	gui.colorPropertyChange(property, $(this).val());
			// });
		});
	}

	/**
	 * Attach events to newly created GUI elements of certain family product
	 * Needs to be called after family is changed
	 */
	attachPropertyEvents():void{
		this.attachEventsProductProperty();
		this.attachEventsScrollProperty();
		this.attachEventsColorProperty();

		// radiobutton change
		let gui = this;
		this.$gui.find('input.property').change(function () {
			let p = gui.app3D.$(this);
			let p_att = p.attr('name');
			let p_val = p.val();

			let close = true;

			if (gui.app3D.data.properties.hasOwnProperty(p_att)){
				gui.app3D.setProperty(p_att, p_val);
				close = !gui.app3D.propertyIsNumeric(p_att);
			}

// update visual representation
			let li = gui.$gui.find('fieldset[data-property="' + p_att +'"]').children('ul').find('li');
			li.removeClass('active');
			li.filter('[data-value="' +p_val+ '"]').addClass('active');
			if (close)
				gui.closeSubmenus();

// update summary
			gui.updatePrice();
		});
	}

	updatePrice() {
		let iProduct = this.$gui.find('input[name="product"]:checked');
		let price = this.app3D.getProduct().price;
		let colors = {};
		let codept = {
			'#': iProduct.attr('data-code')
		};

		_.each(this.app3D.data.properties, (options, property) => {
			let inp = this.$gui.find('input.property[name="' + property + '"]:checked');
			codept[property] = inp.attr('data-code');
//		price += options[inp.val()].price;
		});
		codept['c'] = this.getColorCode(colors);
		let codeData = {};
		_.each(codept, (v, i) => {
			codeData['{' + i + '}'] = v;
		});

		this.$gui.find('#code').val(Utils.replaceAll(this.app3D.data.code_pattern, codeData));
		this.$gui.find('.product-price').find('.amount').text(price);
	}


	getColorCode(colors) {
		let codeParts = [];
		_.each(colors, (v, k) => {
			codeParts.push(k + v);
		});
		return codeParts.join('+');
	}


	setTouchEnvironment():void {
		if (this.isTouch) return;
		this.isTouch = true;
		this.app3D.$('body')
			.addClass('isTouch');

		// close submenus when movement starts
		let hammer = new Hammer(this.app3D.navigator.$eActivate[0], {});
		for (let evt of ['pan']){
			hammer.get(evt).set({	threshold: 0 });
			hammer.on(evt, (e) => {
				this.closeSubmenus();
			});
		}
	}

	/**
	 * Starts pulsing buttons to get attention
	 */
	pulseButtons():void{
		let $buttons = this.$gui.find('button.fs-toggle');
		$buttons
			.addClass('pulse')
			.click(() => $buttons.removeClass('pulse'));
	}

	closeSubmenus() {
		this.$gui.find('fieldset.fs-toggle').removeClass('open');
	}

	takeScreenshot() {
		this.app3D.takeScreenshot(true).then((reportData) => {
			this.reportData = reportData;
		});
		this.app3D.$('#screenshotModal').modal({});
	}

	submitScreenshot() {
		let $scModal = this.app3D.$('#screenshotModal');
		$scModal.addClass('sending');
		this.reportData['email'] = this.app3D.$('input[name="user-email"]').val();

		this.app3D.$.post(this.app3D.config.app_root + this.screenshotProcessorURL, this.reportData, (response) => {
			// report.quit();
			// report.ctl.loading.hide();
			let msgList = this.app3D.$('<ul class="messages"></ul>');
			let eCloseI = this.app3D.$('<li class="close"></li>');
			let eCloseB = this.app3D.$('<button class="btn btn-danger btn-sm"><span class="fa fa-close"></span></button>');
			eCloseB.click(() => {
				msgList.hide();
			});
			eCloseI.append(eCloseB);
			msgList.append(eCloseI);
			_.each(response, (message) => {
				msgList.append('<li class="'+message.class+'">'+message.message+'</li>');
			});
			$scModal.removeClass('sending').modal('hide');

			this.app3D.resume();
		}, 'json');
	}

	/**
	 * Hides all property options except specified ones
	 * @param {string} pID ID of property to update
	 * @param {string[]} options List of options to show
	 */
	updatePropertyOptionListing(pID:string, options: string[]){
		let $opts = this.$gui.find(`fieldset[data-property="${pID}"]`).find('li').not('.option-group');
		$opts.hide();
		for (let opt of options)
			$opts.filter(`li[data-value="${opt}"]`).show();
	}
}



// WEBPACK FOOTER //
// ./src/script/app3D/GUI.ts